var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavbarNew'),_c('div',{staticClass:"container-fluid",staticStyle:{"margin-top":"70px"}},[_c('div',{staticClass:"row ml-0 mr-0"},[_c('div',{staticClass:"col-lg col-md"},[_c('user-card',{staticClass:"borderless-card"})],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }